export default "/images/slide2.jpg?ca9ca0640a89cbf11eb0a41d814e4279";